export default "__VITE_ASSET__D1sFKSLT__"